export default function Featured() {
  return (
    <section className="py-20 px-6 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="order-2 lg:order-1">
            <div className="inline-block bg-[#FFE8E3] text-[#FF6B4A] text-xs font-semibold tracking-wider px-4 py-2 rounded-full mb-6 uppercase">
              Featured
            </div>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-gray-900 leading-tight" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              The Mentorship Platform
            </h2>

            <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8" style={{ lineHeight: '1.8' }}>
              In building a mentoring platform designed to connect people with trusted experts for career guidance, our team focused on creating a seamless, human-centered experience from discovery to connection. I led the design of the search, booking, messaging, and video call journeys shaping the core interactions that enabled meaningful, real-time mentorship at scale.
            </p>

            <div className="flex flex-wrap gap-3 mb-10">
              <span className="bg-gray-100 text-gray-700 px-4 py-2 rounded-full text-sm font-medium">UX Design</span>
              <span className="bg-gray-100 text-gray-700 px-4 py-2 rounded-full text-sm font-medium">Social Connectivity</span>
              <span className="bg-gray-100 text-gray-700 px-4 py-2 rounded-full text-sm font-medium">User Research</span>
              <span className="bg-gray-100 text-gray-700 px-4 py-2 rounded-full text-sm font-medium">Personal Project</span>
            </div>

            <a 
              href="/project/7"
              className="inline-block bg-gray-900 text-white px-8 py-4 rounded-full hover:bg-gray-800 transition-all duration-300 font-semibold shadow-lg whitespace-nowrap cursor-pointer text-base"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              View Case Study →
            </a>
          </div>

          {/* Right Image */}
          <div className="order-1 lg:order-2 relative">
            <div className="relative rounded-[40px] overflow-hidden bg-gradient-to-br from-blue-100 via-purple-50 to-pink-50 p-8">
              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/ed7d6e9501624c265bc1ac340fb9283d/51aeeec9199673bb8b755ee57f84a12a.png"
                  alt="Mobile Banking App Interface"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
